





























import mixins from 'vue-typed-mixins';
import questionsframework, { QuestionKey } from '@/components/survey/questions';
import tabcomponents from './tabs';
import SurveyUtils, { Question } from '@/utils/SurveyUtils';
import cloneDeep from 'lodash.clonedeep';
export default mixins().extend({
  components: {
    ...tabcomponents,
  },

  props: {
    value: {
      type: Object as () => Question,
    },
    questions: {
      type: Array as () => Question[],
    },
  },

  computed: {
    tabs(): any {
      return [
        {
          text: this.$tc('app.label.detail', 2),
          component: 'SurveyQuestionDetailsTab',
        },
        {
          text: this.$tc('model.question.options.label'),
          component: 'SurveyQuestionOptionsTab',
        },
        {
          text: this.$tc('model.question.condition.label'),
          component: 'SurveyQuestionConditionTab',
        },
        {
          text: this.$tc('model.question.validation.label'),
          component: 'SurveyQuestionValidationTab',
        },
        {
          text: this.$tc('model.question.permission.label'),
          component: 'SurveyQuestionPermissionTab',
        },
      ];
    },
  },

  data(): {
    internalQuestions?: Question[];
    tab: number;
  } {
    return {
      internalQuestions: undefined,
      tab: 0,
    };
  },

  watch: {
    'value.questiontype'(newval, preval) {
      if (newval?.key !== preval?.key) {
        this.value.options = {}; // clear options if the questiontype changes
      }
    },

    questions() {
      this.load();
    },
  },

  async mounted() {
    this.load();
  },

  methods: {
    async load() {
      try {
        this.internalQuestions = undefined;

        if (!this.questions) {
          // if questions are not passed, do an API call to get the questions
          this.internalQuestions = await SurveyUtils.api.question.list({
            surveyid: this.value?.survey?.id,
          });
        } else {
          this.internalQuestions = this.questions;
        }
      } catch (error) {
        this.$alert.show('mount', {
          type: 'error',
          messages: this.$handleAPIError(error),
        });
      }
    },
  },
});
